import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';
import FilterButton from 'components/search_sidebar/filter_button';

import CheckboxGroupTags from 'components/search_page/checkbox_group_tags';
import CurrentFilters from 'components/search_page/current_filters';
import FilterRow from 'components/search_page/filter_row';
import FilterTopbar from 'components/search_page/filter_topbar';
import ManagedInput from 'components/form/managed_input';


import {
  changeEventTypeFilter,
  changeStatusFilter,
  changeSearchText,
  clearFilters,
  changeMaxDateFilter,
  changeMinDateFilter
} from './store/actions/query';

import { filterLabelMappings } from './webhook_event_filter_constants';

const statuses = [
  { id: 'success', label: 'Success', value: '2' },
  { id: 'error', label: 'Error', value: '1' },
  { id: 'received', label: 'Received', value: '0' }
];

export class WebhookEventFilterTopbar extends React.Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    eventTypeFilter: PropTypes.array.isRequired,
    eventTypes: PropTypes.array.isRequired,
    maxDate: PropTypes.instanceOf(Date).isRequired,
    minDate: PropTypes.instanceOf(Date).isRequired,
    pageSize: PropTypes.number.isRequired,
    searchText: PropTypes.string.isRequired,
    statusFilter: PropTypes.array.isRequired,
    totalCount: PropTypes.number.isRequired,
    webhookEventCount: PropTypes.number.isRequired,
    onChangeMaxDateFilter: PropTypes.func.isRequired,
    onChangeMinDateFilter: PropTypes.func.isRequired,
    onChangeEventTypeFilter: PropTypes.func.isRequired,
    onChangeSearchText: PropTypes.func.isRequired,
    onChangeStatusFilter: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired
  };

  handleSearchChange = (e) => {
    this.props.onChangeSearchText(e.target.value);
  };

  handleCheckboxGroupChange = (e, name) => {
    const { checked, value } = e.target;
    const { filterKey, onChange } = this.filterMapping[name];
    const filter = [...this.props[filterKey]].filter(selected => selected !== value);
    if (checked) filter.push(value);

    onChange(filter);
  };

  handleEventTypeChange = (e) => {
    this.handleCheckboxGroupChange(e, 'eventType');
  };

  handleStatusChange = (e) => {
    this.handleCheckboxGroupChange(e, 'status');
  };

  filterMapping = {
    eventType: {
      filterKey: 'eventTypeFilter',
      handleChange: this.handleEventTypeChange,
      onChange: this.props.onChangeEventTypeFilter,
      options: this.props.eventTypes.map(type => ({ id: type, label: type, value: type }))
    },
    status: {
      filterKey: 'statusFilter',
      handleChange: this.handleStatusChange,
      onChange: this.props.onChangeStatusFilter,
      options: statuses
    }
  };

  render() {
    return (
      <FilterTopbar>
        <div className="container-fluid">
          {this.renderFilters()}
          <CurrentFilters onClearFilters={this.props.onClearFilters}>
            {this.renderTags()}
          </CurrentFilters>
        </div>
      </FilterTopbar>
    );
  }

  renderFilters() {
    const { currentPage, webhookEventCount, pageSize, searchText, totalCount } = this.props;
    const pageData = {
      currentPage,
      itemCount: webhookEventCount,
      itemSingularLabel: 'webhook event',
      pageSize,
      totalCount
    };

    return (
      <FilterRow
        pageData={pageData}
        searchPlaceholder="Search by identifier or request"
        searchText={searchText}
        onSearchChange={this.handleSearchChange}
      >
        {this.renderCheckboxGroupFilter('status')}
        {this.renderCheckboxGroupFilter('eventType')}
        <div className="form-group-lg left-buffer-md right-buffer-md">
          {
            <ManagedInput
              className="datetime-picker form-control"
              name="createdMinDate"
              placeholder="Received At Date"
              showTimeSelect
              type="date"
              value={this.props.minDate}
              onValueChange={this.props.onChangeMinDateFilter}
            />
          }
        </div>
        <div className="form-group-lg top-buffer-sm">
          TO
        </div>
        <div className="form-group-lg left-buffer-md">
          {
            <ManagedInput
              className="datetime-picker form-control"
              name="createdMaxDate"
              placeholder="Received At Date"
              showTimeSelect
              type="date"
              value={this.props.maxDate}
              onValueChange={this.props.onChangeMaxDateFilter}
            />
          }
        </div>
      </FilterRow>
    );
  }

  renderCheckboxGroupFilter(name) {
    const { filterKey, handleChange, options } = this.filterMapping[name];
    const filter = this.props[filterKey];

    return (
      <FilterButton filtersApplied={filter.length > 0} label={filterLabelMappings[name]} name={name}>
        <FilterCheckboxGroup
          name={`${name}InputGroup`}
          options={options}
          selected={filter}
          onChange={handleChange}
        />
      </FilterButton>
    );
  }

  renderCurrentFilters() {
    const tags = this.renderTags();

    if (tags.length === 0) return null;

    return (
      <div className="top-buffer-xs">{tags}</div>
    );
  }

  renderTags() {
    const tags = [];
    this.renderCheckboxGroupTags(tags, 'status');
    this.renderCheckboxGroupTags(tags, 'eventType');

    return tags;
  }

  renderCheckboxGroupTags(tags, name) {
    const { filterKey, handleChange, options } = this.filterMapping[name];
    const filter = this.props[filterKey];
    if (filter.length === 0) return;

    const label = filterLabelMappings[name];

    tags.push(
      <CheckboxGroupTags
        filter={filter}
        key={`${name}_tags`}
        label={label}
        name={name}
        options={options}
        onRemove={handleChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  ...state.search.meta,
  ...state.query,

  webhookEventCount: state.search.webhookEvents.length
});

const mapDispatchToProps = {
  onChangeMinDateFilter: changeMinDateFilter,
  onChangeMaxDateFilter: changeMaxDateFilter,
  onChangeEventTypeFilter: changeEventTypeFilter,
  onChangeStatusFilter: changeStatusFilter,
  onChangeSearchText: changeSearchText,
  onClearFilters: clearFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(WebhookEventFilterTopbar);
